import React, { Component } from "react";
import {
  Container,
} from "@mui/material";
import {
  notification,
  notificationTypes
} from "../../../utils/notification";
import {
  ServiceInfo,
  CountriesList,
  PopularCountries
} from "./components";
import {
  LoadingContent
} from "../../../components";
import agent from "../../../agent/agent";
import getTrans from "../../../languages/getTrans";

class ServiceSlug extends Component {
  constructor(props) {
    super(props);

    this.state = {
      service: null,
      countries: [],
      isLoading: true,
      isLoadingCountries: true,
    };
  }

  componentDidMount = async () => {
    await this.getService();
  }

  getService = async () => {
    const slug = this.props?.match?.params?.slug || "";
    const userId = this.props?.userId;
    const service = await agent.get(`/api/service/get-service-data/${slug}?user=${userId}`).then((res) => res.data?.service || null).catch(() => null)
    if (!service) {
      notification({
        type: notificationTypes.error,
        message: getTrans('serviceSlug.По вашему запросу ничего не найдено')
      })
      this.props.history.push("/services");
      return
    }

    await this.setState({service, isLoading: false});
    await this.getCountries({id: service.id, userId});
  }
  getCountries = async ({ id, userId }) => {
    const countries = await agent.get(`/api/country/get-prices/${ id }?wholesale=0&user=${userId}`).then((res) => res.data).catch(() => []);
    this.setState({
      countries,
      isLoadingCountries: false
    })
  }

  render() {
    const {
      service,
      countries,
      isLoading,
      isLoadingCountries
    } = this.state;

    if (isLoading) {
      return (<LoadingContent removeBg/>)
    }
    return (
      <>
        <ServiceInfo title={service.name} iconId={service.icon_id} />
        <Container sx={{height: "calc(100vh - 104px)", overflow: "auto", padding: "0 8px", paddingTop: "12px"}}>
          <PopularCountries items={service.favorite_countries} />
          <CountriesList items={countries} isLoading={isLoadingCountries} />
        </Container>
      </>
    );
  }
}

export default ServiceSlug
